import { useLocation } from "react-router-dom";
import Logo from "../Logo/Logo";
import { routes } from "../../shared/router/routes";
import { useContext, useMemo, useEffect, useCallback } from "react";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { APP_CONFIGS } from "../../shared/constants";
import Button from "../Button/Button";
import { LayoutContext } from "../../shared/providers/layout/layout.provider";
import Link from "../Link/Link";
import LanguangeMenu from "../LanguageMenu/LanguageMenu";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";

function Navbar({ layoutRef }: { layoutRef: React.RefObject<HTMLElement> }) {
    const location = useLocation();
    const { translate } = useContext(TranslationContext);
    const { handleMenu } = useContext(LayoutContext);
    const { setConfirmLogout } = useContext(AuthenticationContext);

    const menu = useMemo(
        () =>
            [
                {
                    icon: "Home",
                    href: routes.HOME.path,
                    label: translate("nav.home", "Home"),
                    enabled: true
                },
                {
                    icon: "Sprout",
                    href: routes.DSS.path,
                    label: translate("nav.dss", "Workplace Assessment"),
                    enabled: true
                },
                {
                    icon: "Explore",
                    href: routes.EXPLORE.path,
                    label: translate("nav.all_topics", "All Topics"),
                    enabled: true
                },
                {
                    icon: "Help",
                    href: routes.FAQS.path,
                    label: translate("nav.faqs", "FAQ"),
                    enabled: true
                },
                {
                    icon: "Enterprise",
                    href: routes.ABOUT.path,
                    label: translate("nav.about_prosperh", "What is PROSPERH?"),
                    enabled: true
                },
                {
                    icon: "User--multiple",
                    href: routes.CONTACTS.path,
                    label: translate("nav.contact_feedback", "Contact & Feedback"),
                    enabled: true
                },
                {
                    icon: "Document",
                    href: routes.TRANSLATIONS.path,
                    label: translate("nav.languages", "Languages"),
                    enabled: APP_CONFIGS.dev
                },
                {
                    icon: "Document",
                    href: routes.TYPEFORMS.path,
                    label: "Typeforms",
                    enabled: APP_CONFIGS.dev
                },
                {
                    icon: "edit",
                    href: routes.STYLEGUIDE.path,
                    label: translate("nav.styleguide", "Styleguide"),
                    enabled: APP_CONFIGS.dev
                }
            ].filter((m) => m.enabled),
        [translate]
    );

    useEffect(() => {
        handleMenu(false);
    }, [location]);

    const isItemActive = useCallback(
        (href: string) => {

            if (location.pathname === "/") return location.pathname === href;

            if (location.pathname.includes("/module")) return href === routes.EXPLORE.path;

            return location.pathname.match(href) && href !== "/"
        },
        [location]
    );

    return (
        <>
            <nav
                className="navbar pt-13 pt-md-31 pb-21 d-flex flex-column"
                ref={layoutRef}>
                <Link to="/" customCss="p-0"><Logo isWhite className="d-none d-md-block" /></Link>
                <Button
                    type="button"
                    customCss="ms-auto color-neutrals-white d-md-none"
                    icon="Close"
                    iconSize={24}
                    onClick={() => handleMenu()}
                />
                <ul className="menu ps-md-2">
                    {menu.map((item, i) => (
                        <li key={i} className={isItemActive(item.href) ? "is_active" : ""}>
                            <Link
                                to={item.href}
                                icon={item.icon}
                                iconSize={32}
                                label={item.label}
                                customCss="text-bd1-smbd justify-content-start ps-1 ps-md-12"
                            />
                        </li>
                    ))}
                </ul>

                <ul className="menu mt-auto d-md-none">
                    <li>
                        <LanguangeMenu />
                    </li>
                    <li>
                        <Button
                            type="button"
                            icon="Logout"
                            label="Logout"
                            onClick={() => setConfirmLogout(true)}
                            customCss="text-bd1-smbd color-neutrals-white justify-content-start ps-1 ps-md-12 w-100"
                        />
                    </li>
                </ul>
            </nav>
        </>
    );
}

export default Navbar;
